import axios from 'axios';
import {$message,Loading} from 'element-ui';
import {Encrypt,Decrypt,getLocal,removeLocal,utils} from '../assets/js/utils';

// axios.defaults.baseURL = 'http://192.168.50.22:8080/'; //海鹏
// axios.defaults.baseURL = 'http://192.168.50.41:7085/'; //长旭
axios.defaults.baseURL = '//noa.cisdom.com.cn/inter/'; //正式

// axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
  export function get(options={url:'',data:{},isToken:true,loading:'loading'}) {
    let loading=options.loading==undefined?'loading':options.loading;
    let spinner=options.loading==''?'':'el-icon-loading';
    let bgColor=options.loading=='rgba(0, 0, 0, 0)'?'':'rgba(0, 0, 0, 0.2)';
    let isToken=options.isToken==undefined?true:options.isToken;
    let data=options.data||{};
    let header={'Authorization':'1111'};
    if(isToken){

      if(!getLocal('oaToken')){
        this.$message.warning('登录失效，请重新登录');
        setTimeout(() => {
          this.$router.replace({
            path: '/login',
            query: {
            redirect: this.$router.currentRoute.fullPath
            }
          });
        }, 1000);
        return new Promise((resolved,reject)=>{})
      }else{
        let token='Bearer-'+getLocal('oaToken');
        header={
          'Authorization':token
        }

      }
    }
    let loadingInstance;
    if(loading!='false'){
      loadingInstance= Loading.service({
        lock: true,
        text: loading,
        spinner: spinner,
        background: bgColor
      });
    }
    //console.log(options.url+'请求参数：',data)
    let p=new Promise((resolve, reject) => {
      axios.get(
        options.url,
        'params='+encodeURIComponent(Encrypt(JSON.stringify(data))),
        {headers: header})
        .then(res => {
          if(loading!='false')loadingInstance.close();
          switch (res.data.status){
            case 200:
              //console.log(options.url+'获取正确的数据：',res.data.result)
              resolve(res.data.result);
              break;
            case 604://登录失效
              this.$message.warning('登录失效，请重新登录');
              // 清除token
              removeLocal('zdOaInfo')
              removeLocal('permissionList');
              // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
              this.$router.replace({
                path: '/login',
                query: {
                redirect: this.$router.currentRoute.fullPath
                }
               });
              break;
            default:
              //console.log('获取错误的数据：',res.data)
              this.$message.warning(res.data.message);
              reject(res.data)
              break;
          }
        },()=>{
          if(loading!='false')loadingInstance.close();
          this.$message.error('网络错误，请检查网络');
        })
    })
    return p;
  }
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(options={url:'',data:{},isToken:true,loading:'loading'}) {
  let loading=options.loading==undefined?'loading':options.loading;
  let spinner=options.loading=='el'?'':'el-icon-loading';
  let bgColor=options.loading==''?'rgba(0, 0, 0, 0)':'rgba(0, 0, 0, 0.2)';
  let isToken=options.isToken==undefined?true:options.isToken;
  let data=options.data||{};
  let header={'Authorization':'1111'};


  if(isToken){
    if(!getLocal('oaToken')){
      this.$message.warning('登录失效，请重新登录!');
      setTimeout(() => {
        this.$router.replace({
          path: '/login',
          query: {
          redirect: this.$router.currentRoute.fullPath
          }
        });
      }, 1000);
      return new Promise((resolved,reject)=>{})
    }else{
      let token='Bearer-'+getLocal('oaToken');
      header={
        'Authorization':token
      }

    }
  }
  let loadingInstance;
  if(loading!='false'){
    loadingInstance= Loading.service({
      lock: true,
      text: loading,
      spinner: spinner,
      background: bgColor
    });
  }
  console.log(options.url+'请求参数：',data)
  let backStatus;
  let p=new Promise((resolve, reject) => {
    axios.post(
      options.url,
      'params='+encodeURIComponent(Encrypt(JSON.stringify(data))),
      // 'params='+encodeURIComponent(JSON.stringify(data)),
      {headers: header,
       validateStatus: function (status) {
         if(status == 200){
           return true;
         }else{
          backStatus = status;
          return false;
         }

         // default
      },
      })
      .then(res => {
        if(loading!='false')loadingInstance.close();
         switch (res.data.status){
           case 200:
            console.log(options.url+'获取正确的数据：',res.data.result);
             resolve(res.data.result);

            break;
          // case 604://登录失效
          //   this.$message.warning('登录失效，请重新登录');
          //   清除token
          //   removeLocal('zdOaInfo')
          //   removeLocal('permissionList');
          //   //跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          //   this.$router.replace({
          //     path: '/login',
          //     query: {
          //     redirect: this.$router.currentRoute.fullPath
          //     }
          //    });
          //    break;
           default:
            console.log('获取错误的数据：',res.data)
            this.$message.warning(res.data.message);
             reject(res.data);
             break;
        }
      },(error)=>{
        //console.log(error)
        if(backStatus == 401){
          if(loading!='false')loadingInstance.close();
          this.$message.warning('登录时间过长，请重新登录');
          let timer = setTimeout(() => {
            removeLocal('zdOaInfo')
            removeLocal('permissionList');
            this.$router.push('/login');
            clearTimeout(timer);
          },1000) ;
          return false;
        }else{
          if(loading!='false')loadingInstance.close();
          this.$message.error('网络错误，请检查网络');
          return false;
        }


      })

  });

  return p;


}




// WEBPACK FOOTER //
// ./src/request/http.js